// routes/_app.profile.edit.notification.tsx
import { dynamic } from 'src/utils/ssr'

const getClientModule = () => import('src/clientRoutes/_app.profile.edit.notification')

export const handle = {
  name: 'profile/edit/notification',
  track: { scene: 'profile-edit', section: 'notification' },
}

export default dynamic(getClientModule, { ssr: false })
